<script setup>
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';
import { useI18n } from 'vue-i18n';

defineProps({
  selectedContact: {
    type: Object,
    required: true,
  },
  primaryContactId: {
    type: [Number, null],
    default: null,
  },
  primaryContactList: {
    type: Array,
    default: () => [],
  },
  isSearching: {
    type: Boolean,
    default: false,
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:primaryContactId', 'search']);

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex flex-col gap-[6px]">
      <label class="text-sm dark:text-n-gray-5">
          {{ t('CONTACTS_LAYOUT.SIDEBAR.MERGE.PRIMARY') }}
      </label>        
      <ComboBox
        id="inbox"
        :model-value="primaryContactId"
        :options="primaryContactList"
        :empty-state="
          isSearching
            ? t('CONTACTS_LAYOUT.SIDEBAR.MERGE.IS_SEARCHING')
            : t('CONTACTS_LAYOUT.SIDEBAR.MERGE.EMPTY_STATE')
        "
        :search-placeholder="
          t('CONTACTS_LAYOUT.SIDEBAR.MERGE.SEARCH_PLACEHOLDER')
        "
        :placeholder="t('CONTACTS_LAYOUT.SIDEBAR.MERGE.PLACEHOLDER')"
        :has-error="hasError"
        :message="errorMessage"
        class="merge-combobox"
        @update:model-value="value => emit('update:primaryContactId', value)"
        @search="query => emit('search', query)"
      />
      <span
          class="text-sm text-n-teal-11"
        >
          {{ t('CONTACTS_LAYOUT.SIDEBAR.MERGE.PRIMARY_HELP_LABEL') }}
        </span>
    </div>
    <div class="flex justify-center gap-2">
      <i class="i-lucide-arrow-up w-6 h-6" />
      <i class="i-lucide-arrow-down w-6 h-6" />
    </div>
    <div class="flex flex-col gap-[6px]">
        <label class="text-sm dark:text-n-gray-5">
          {{ t('CONTACTS_LAYOUT.SIDEBAR.MERGE.PARENT') }}
        </label>        
        
      <div
        class="border border-n-strong h-10 gap-2 flex items-center input-base"
      >
        <Avatar
          :name="selectedContact.name || ''"
          :src="selectedContact.thumbnail || ''"
          :size="20"
          rounded-full
        />
        <div class="flex flex-col w-full min-w-0 gap-1">
          <span class="text-base leading-4 truncate dark:text-n-gray-3">
            {{ selectedContact.name }}
          </span>
          <!-- <span class="text-sm leading-4 truncate text-n-slate-11">
            {{ selectedContact.email }}
          </span> -->
        </div>
      </div>
      <span
          class="text-sm text-hilab"
        >
          {{ t('CONTACTS_LAYOUT.SIDEBAR.MERGE.PARENT_HELP_LABEL') }}
        </span>
    </div>
  </div>
</template>
<style scoped>
.merge-combobox :deep(button) {
  @apply bg-transparent dark:text-n-gray-5 dark:text-base;
}
</style>
